import script from "./split-input-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./split-input-button.vue?vue&type=script&lang=ts&setup=true"

import "./split-input-button.vue?vue&type=style&index=0&id=49b17756&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b17756"]])

export default __exports__